var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { observable, action, runInAction, makeObservable } from "mobx";
export var NS = "translation";
export var languages = [
    {
        short: "en",
        fullName: "English",
        display: "English (EN)",
    },
    {
        short: "de",
        fullName: "German",
        display: "Deutsch (DE)",
    },
    {
        short: "ru",
        fullName: "Russian",
        display: "Pусский (RU)",
    },
    {
        short: "pt",
        fullName: "Portuguese",
        display: "Português (Brasil) (PT-BR)",
    },
    {
        short: "es",
        fullName: "Spanish",
        display: "Español (ES)",
    },
];
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    fallbackLng: "en",
    debug: false,
    resources: {},
    interpolation: {
        escapeValue: false,
    },
    detection: {
        order: ["cookie", "localStorage", "querystring", "navigator"],
    },
});
var i18next = /** @class */ (function () {
    function i18next() {
        var _this = this;
        this.addResourceBundle = i18n.addResourceBundle;
        this.language = i18n.language;
        this.addTranslation = function (translationsArray) {
            translationsArray.forEach(function (translation) {
                i18n.addResourceBundle(translation.language, NS, translation.phrases.reduce(function (fullObj, phrase) {
                    fullObj[phrase.key] = phrase.value;
                    return fullObj;
                }, {}));
            });
        };
        this.changeLanguage = function (lg) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, i18n.changeLanguage(lg)];
                    case 1:
                        _a.sent();
                        //setLocale added soon to date-fns
                        this.t = i18n.getFixedT(lg);
                        return [2 /*return*/];
                }
            });
        }); };
        runInAction(function () {
            _this.t = i18n.t.bind(i18n);
        });
        makeObservable(this, {
            t: observable,
            addResourceBundle: observable,
            language: observable,
            changeLanguage: action,
        });
    }
    return i18next;
}());
export default new i18next();
//# sourceMappingURL=data:application/json;base64,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